
export function uniqueArrayOfObjects(array) {
    // 将对象转换为字符串，并使用Set去重
    const unique = Array.from(new Set(array.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
    return unique;
}